import tracking from 'dibs-tracking';

const gaActions = {
    'register': 'registration',
    'password-only': 'login',
    'reset-password': 'reset password',
    'forgot-password': 'forgot password',
    'reset-invalid': 'reset invalid',
    'update-password': 'update password',
    '/about/privacy-policy/': 'legal text',
    '/about/useragreement/': 'legal text',
    'confirm': 'verification'
};

function getGaAction(action) {
    return gaActions[action] || action || "";
}

function getGaCategory(action) {
    return getGaAction(action).replace(' verification', '');
}

function getFormInteractionLabel(interaction) {
    switch (interaction) {
        case 'two':
            return 'registration step 1 completed (email)';

        case 'user-type':
            return 'registration step 2 completed (password)';

        case 'checkout embedded login':
            return 'log in on embedded checkout registration form';
    }
    return '';
}

export function fireAuthModalEvent(gaObj, flowStep) {
    const action = getGaAction(gaObj.action);
    const category = getGaCategory(action);
    tracking.trackEvent({
        category: category,
        action: action + ' ' + flowStep,
        label: gaObj.label,
        value: gaObj.value
    });

}

export function fireFormInteractionEvent(action, interaction, other, additional) {
    const formattedAction = getGaAction(action);
    const category = getGaCategory(action);
    const label = getFormInteractionLabel(interaction, other);
    if (formattedAction && label) {
        tracking.trackEvent({
            action: formattedAction + ' form interaction',
            additional: additional || {},
            category,
            label
        });
    }
};



// WEBPACK FOOTER //
// ./assets/js/auth/trackingHelpers.es.js